<template>
  <div class="leftContent">
    <div class="title-row-download">
      <div class="commonTitle">{{ $tt("客户端下载") }}</div>
    </div>
    <ClientDownloadHub layout="home" :welcome-list="welcomeList" />

    <div class="aux-section">
      <div class="title-row-download aux-title-row">
        <div class="commonTitle commonTitle--sub">{{ $tt("辅助工具下载") }}</div>
      </div>
      <div class="shortActions">
        <el-row :gutter="20">
          <el-col :span="6" v-for="a in auxiliaryActions" :key="a.id">
            <a
              class="action"
              target="_blank"
              :href="a.href || '#'"
              @click.prevent="onAuxiliaryClick(a)"
            >
              <img class="icon" :src="resolveDownloadIcon(a)" :alt="$tt(a.name)" />
              <span class="text">{{ $tt(a.name) }}</span>
            </a>
          </el-col>
        </el-row>
        <el-empty
          v-if="auxiliaryLoaded && !auxiliaryActions.length"
          :description="$tt('暂无辅助工具')"
        />
      </div>
    </div>

    <div class="modulesWrap">
      <div class="title">
        <div class="commonTitle">{{ $tt("工程模板") }}</div>
        <div class="more" @click="toMorePage">{{ $tt("更多模板") }}</div>
      </div>

      <div class="modules">
        <el-row :gutter="20">
          <el-col :span="6" v-for="m in modules" :key="m.key">
            <TemplateC
              :template="m"
              :deleteCommonTemplate="
                isManager ? deleteCommonTemplate : undefined
              "
              :useCommonTemplate="useCommonTemplate"
            />
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import TemplateC from "@/components/Template";
import ClientDownloadHub from "@/components/ClientDownloadHub.vue";
import { mapState } from "vuex";
import { resolveDownloadIcon } from "@/utils/downloadIcons";
import { isAuxiliaryWelcomeEntry } from "@/utils/clientPlatforms";

export default {
  components: {
    TemplateC,
    ClientDownloadHub,
  },
  data() {
    return {
      welcomeList: [],
      auxiliaryActions: [],
      auxiliaryLoaded: false,
      modules: [],
    };
  },
  computed: {
    ...mapState(["projectLevels"]),
    ...mapState({
      isManager: (state) => state.loginAccountInfo.is_manage,
    }),
  },
  mounted() {
    this.$store.dispatch("getProjectLevelsAction", {});
    this.getCommonTemplatesList({});
    this.getDownloadList();
  },
  methods: {
    resolveDownloadIcon,
    onAuxiliaryClick(a) {
      if (a.href) {
        window.open(a.href, "_blank", "noopener,noreferrer");
      }
    },
    getDownloadList() {
      this.$request.getDownloadList().then((res) => {
        if (res.status != "success") {
          this.$message.error(res.msg);
          return;
        }
        const list = res.data || [];
        this.welcomeList = list;
        this.auxiliaryActions = list.filter(isAuxiliaryWelcomeEntry);
        this.auxiliaryLoaded = true;
        this.setGuideUrl(list);
      });
    },
    setGuideUrl(datas) {
      if (datas && datas.length > 0) {
        for (let i = 0; i < datas.length; i++) {
          let item = datas[i];
          if (item.name === "快速上手指南") {
            sessionStorage.setItem("newGuideUrl", item.href);
            break;
          }
        }
      }
    },
    toMorePage() {
      this.$router.push("/homePage/moreTemplates");
    },
    getCommonTemplatesList({ page_size = 8, page_num = 1 }) {
      this.$request
        .queryCommonTemplates({ page_size, page_num })
        .then((res) => {
          if (res.status != "success") {
            this.$message.error(res.msg);
            return;
          }
          this.modules = (res?.data?.result || []).map((t) => ({
            text: t.project_name,
            picture: t.project_img,
            type: t.type,
            id: t.id,
            fileType: "image",
          }));
        });
    },
    deleteCommonTemplate(id) {
      this.$request.deleteCommonTemplates({ id }).then((res) => {
        if (res.status != "success") {
          this.$message.error(res.msg);
          return;
        }
        this.$message.error("删除成功");
        this.getCommonTemplatesList({});
      });
    },
    useCommonTemplate(id, type) {
      const { btns, pages, ip_ports, project_code } = this.projectLevels.find(
        (l) => l.project_code == type
      );
      const limits = btoa(
        JSON.stringify({ project_code, pages, btns, ip_ports })
      );
      this.$router.push({
        path: "/projects/projectsEdit",
        query: {
          limits,
          id,
          isCommonTemplate: true,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.leftContent {
  flex: 1;
  padding-right: 24px;
  .title-row-download {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 8px;
  }
  .aux-section {
    margin-top: 28px;
    padding-top: 8px;
    border-top: 1px solid #ebeef5;
  }
  .aux-title-row {
    margin-bottom: 4px;
  }
  .commonTitle {
    font-size: 22px;
    &--sub {
      font-size: 20px;
      color: #303133;
    }
  }
  .shortActions {
    .action {
      display: flex;
      align-items: center;
      background-color: rgb(240, 242, 245);
      border-radius: 12px;
      justify-content: center;
      cursor: pointer;
      text-decoration: none;
      color: #000;
      height: 120px;
      margin-top: 16px;
    }
    .text {
      font-size: 17px;
      margin-left: 10px;
    }
    .icon {
      width: 48px;
      height: 48px;
      object-fit: contain;
      flex-shrink: 0;
    }
  }
  .modulesWrap {
    margin-top: 32px;
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 80px;
    }
    .more {
      cursor: pointer;
    }
  }
}
</style>
